import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { FolderDTO } from '../types';

const url = `${PREFIX_URL}/projects/:projectId/library/folders`;

export type GetFoldersResponse = {
  status: boolean;
  data: FolderDTO[];
};

export const getFoldersQueryKey = {
  list: ['getFolders'] as const,
};

export const getFolders = ({
  projectId,
  inTrash,
  showError = true,
}: {
  projectId: number;
  inTrash: boolean;
  showError?: boolean;
}): Promise<GetFoldersResponse> => {
  const URL = generateRoutePath(url, { projectId });

  return axios.get(URL, {
    params: {
      ...(inTrash ? { trash: true } : {}),
    },
    showError,
  });
};
type QueryFnType = typeof getFolders;

type UseGetFoldersOptions = {
  projectId: number;
  inTrash?: boolean;
  showError?: boolean;
  config?: QueryConfig<QueryFnType>;
};

export const useGetFolders = ({
  projectId,
  inTrash = null,
  showError = true,
  config = {},
}: UseGetFoldersOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [...getFoldersQueryKey.list, projectId, inTrash, showError],
    queryFn: () => getFolders({ projectId, inTrash, showError }),
    cacheTime: 5000,
    staleTime: 5000,
    // cacheTime: 0,
    // staleTime: Infinity,
    ...config,
  });
};
